import { ChangeDetectionStrategy, Component, ElementRef, ViewChild } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import * as d3 from "d3";

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-basic-bar-chart-grid',
    template: `<div #gridBarChartContainer></div>`,
    standalone: false
})
export class BasicBarChartGridComponent implements ICellRendererAngularComp {

  @ViewChild("gridBarChartContainer", { static: true }) gridBarChartContainer!: ElementRef;
  public params: any;

  data: any = [];
  columnWidth: number = 100;

  agInit(params: any): void {
    this.params = params;
    let barChartProperties = this.params?.['barChartProperties'] || [];

    if (barChartProperties.length > 0) {
      this.data = barChartProperties.map((f: any) => ({
        value: +this.params?.data?.[f?.from_value] || 0,
        color: f.color,
        name: f?.from_value
      }));
    } else {
      this.data = [];
    }

    // Get real AG Grid column width
    this.columnWidth = params.column?.getActualWidth?.() || 120;

    this.createChart();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.params.api.resetRowHeights();
    }, 0);
  }

  refresh(params: any): boolean {
    this.params = params;
    // update column width on refresh (e.g., resize)
    this.columnWidth = params.column?.getActualWidth?.() || 120;
    this.createChart();
    return true;
  }

  private createChart(): void {
    const element = this.gridBarChartContainer.nativeElement;
    d3.select(element).selectAll("*").remove();

    const width = this.columnWidth - 30; // small padding
    const height = 50;

    const svg = d3.select(element)
      .append('svg')
      .attr('width', width)
      .attr('height', height);

    const barHeight = 5;
    const spacing = 12;

    // scale values to fit inside column width
    const maxVal:any = d3.max(this.data, (d: any) => d.value) || 1;
    const xScale = d3.scaleLinear()
      .domain([0, maxVal])
      .range([0, width]);

    svg.selectAll('rect')
      .data(this.data)
      .enter()
      .append('rect')
      .attr('x', 0)
      .attr('y', (d, i) => i * spacing + 8)
      .attr('width', (d: any) => xScale(d.value))
      .attr('height', barHeight)
      .attr('rx', 2)
      .attr('fill', (d: any) => d.color);
  }
}
